import styled from "styled-components";
import { tokens } from "../../../../../public/tokens";

export const SummaryCard = styled.div`
    border: 1px solid ${tokens.colors.surfaces["border-divider"]};
    border-radius: ${tokens.globals["border-radius"]};
    background-color: ${tokens.colors.surfaces["container-background"]};
    overflow: hidden;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
`;

export const SummaryHeader = styled.div`
    padding: 12px;
    border-bottom: 1px solid ${tokens.colors.surfaces["border-divider"]};
`;

export const SummaryTitle = styled.div`
    font-size: ${tokens.typography.fontSize['base-16px']};
    font-weight: ${tokens.typography.fontWeights.bold};
    color: ${tokens.colors.text.primary};
    margin-bottom: 4px;
`;

export const SummarySubtitle = styled.div`
    font-size: ${tokens.typography.fontSize['lg-14px']};
    color: ${tokens.colors.text.secondary};
`;

export const SummaryModulesList = styled.div`
    max-height: 450px;
    overflow-y: auto;
    scrollbar-gutter: stable;

    scrollbar-width: thin;
    scrollbar-color: var(--scrollbar-thumb-color, var(--scrollColor)) transparent;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: var(--scrollbar-thumb-color, var(--scrollColor));
        border-radius: 999px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }
`;

export const SummaryModuleItem = styled.div`
    padding: 8px 12px;
    min-height: 50px;
    display: flex;
    flex-direction: ${props => props.$isEdit ? "row" : "column"};
    align-items: ${props => props.$isEdit ? "center" : "stretch"};
    justify-content: ${props => props.$isEdit ? "space-between" : "center"};
    gap: 8px;
                                                   
`;

export const SummaryModuleInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
`;

export const SummaryModuleName = styled.div`
    font-size: ${tokens.typography.fontSize['lg-14px']};
    color: ${tokens.colors.text.primary};
`;

export const SummaryModuleDetails = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
  
`;

export const SummaryModulePrice = styled.span`
    font-size: ${tokens.typography.fontSize['lg-14px']};
    font-weight: ${tokens.typography.fontWeights.bold};
    color: ${props => props.$isCredit ? `var(--green, ${tokens.colors.states.success.default})` : `var(--black1, ${tokens.colors.text.primary})`};
`;

export const SummaryModuleTag = styled.span`
    padding: 3px;
    border-radius: ${tokens.globals["border-radius"]};
    font-size: ${tokens.typography.fontSize['sm-10px']};
    font-weight: ${tokens.typography.fontWeights.bold};
    display: inline-flex;
    align-items: center;
    gap: 2px;
    background-color: ${props => {
        if (props.$type === "redo") return "rgba(193, 35, 44, 0.1)";
        if (props.$type === "adjustment" || props.$type === "credit") return "rgba(246, 142, 49, 0.1)";
        if (props.$type === "progression") return "rgba(57, 180, 194, 0.1)";
        return "transparent";
    }};
    color: ${props => {
        if (props.$type === "redo") return tokens.colors.states.alert.default;
        if (props.$type === "adjustment" || props.$type === "credit") return tokens.colors.states.warning.default;
        if (props.$type === "progression") return tokens.colors.states.info.default;
        return tokens.colors.text.primary;
    }};
`;

export const SummaryFooter = styled.div`
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    @media (max-width: 768px) {
        gap: 12px;
    }
`;

export const SummaryHeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
`;

export const SummaryActions = styled.div`
    display: none;
    align-items: center;
    gap: 8px;
    @media (max-width: 1024px) {
        display: flex;
    }
`;

export const SummaryToggleButton = styled.button`
    border: 1px solid ${tokens.colors.surfaces["border-divider"]};
    background: ${tokens.colors.neutral.white};
    color: ${tokens.colors.theme["button-color"]};
    border-radius: ${tokens.globals["border-radius"]}'
    width: 36px;
    height: 36px;
    min-width: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
`;

export const MobileOnly = styled.div`
    display: none;
    @media (max-width: 1024px) {
        display: block;
    }
`;

export const ProgressTrackWrapper = styled.div`
    margin-top: 5px;
`;

export const ProgressTrackBackground = styled.div`
    width: 100%;
    height: 15px;
    border-radius: ${tokens.globals["border-radius"]};
    background-color: ${tokens.colors.surfaces["border-divider"]};
    overflow: hidden;
`;

export const ProgressTrackFill = styled.div`
    height: 15px;
    border-radius:  ${tokens.globals["border-radius"]};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    box-sizing: border-box;
    background-image: ${props => {
        if (props.$status === "none") {
            return "linear-gradient(90deg, var(--scrollColor) 0%, var(--scrollColor) 100%)";
        }
        if (props.$status === "error") {
            return "linear-gradient(90deg, #c1232c 0%, #ff6b6b 100%)";
        }
        return "linear-gradient(90deg, #467fcf 0%, #79b3ff 199.29%)";
    }};
    width: ${(props) => props.$percent}%;
`;

export const ProgressTrackLabel = styled.div`
    font-size: ${tokens.typography.fontSize['sm-10px']};
    font-weight: ${tokens.typography.fontWeights.bold};
    padding: 0 2px;
    text-align: center !important;
    width: 100%;
    color: ${tokens.colors.neutral.white};
    white-space: nowrap;
`;

export const ProgressTrackHelper = styled.div`
    margin-top: 3px;
    font-size: ${tokens.typography.fontSize['sm-10px']};
    font-weight: ${tokens.typography.fontWeights.semibold};
    color: ${tokens.colors.text.secondary};
`;

export const SummaryRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    font-size: ${tokens.typography.fontSize['lg-14px']};
`;

export const SummaryRowTitle = styled.div`
    font-weight: ${tokens.typography.fontWeights.regular};
    color: ${tokens.colors.text.primary};
`;

export const SummaryRowAmount = styled.div`
    font-size: ${tokens.typography.fontSize['md-12px']};
    font-weight: ${tokens.typography.fontWeights.bold};
    color: ${(props) => props.$color || tokens.colors.text.primary};
`;

export const SummaryHelperText = styled.p`
    margin: 8px 0 0 0;
    font-size: ${tokens.typography.fontSize['sm-10px']};
    line-height: ${tokens.typography.lineHeights['110']};
    color: ${(props) => props.$color || tokens.colors.text.secondary};
`;

export const SummaryTotalRow = styled.div`
    margin-top: 12px;
    padding-top: 14px;
    padding-bottom: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: ${tokens.typography.fontSize['base-16px']};
    border-top: 1px solid ${tokens.colors.surfaces["border-divider"]};
`;

export const SummaryTotalLabel = styled.span`
    color: ${tokens.colors.text.primary};
    font-size: ${tokens.typography.fontSize['lg-14px']};
    font-weight: ${tokens.typography.fontWeights.regular};
    line-height: ${tokens.typography.lineHeights['110']};
`;

export const SummaryTotalAmount = styled.span`
    font-weight: ${tokens.typography.fontWeights.bold};
    font-size: ${tokens.typography.fontSize["2xl-20px"]};
    color: ${tokens.colors.text.primary};
    display: flex;
    align-items: flex-start;
    gap: 2px;
`;

export const SummaryDisclaimerBlock = styled.div`
    display: flex;
    padding-top: 8px;
    align-items: baseline;
    gap: 4px;
    font-size: ${tokens.typography.fontSize['lg-14px']};
    text-wrap: pretty;
    line-height: ${tokens.typography.lineHeights['110']};
    color: ${tokens.colors.ui.destructive};
    font-weight: ${tokens.typography.fontWeights.regular};
    unicode-bidi: isolate;
    font-style: italic;
`;

export const SummaryDisclaimer = styled.div`
    display: flex;
    padding:0;
    align-items: baseline;
    gap: 4px;
    font-size: ${tokens.typography.fontSize['sm-10px']};
    text-wrap: pretty;
    line-height: ${tokens.typography.lineHeights['110']};
    color: ${tokens.colors.states.alert.default};
    font-weight: ${tokens.typography.fontWeights.regular};
    unicode-bidi: isolate;
`;

export const SummaryDisclaimerText = styled.span`
    color: ${tokens.colors.text.secondary};
`;

export const TotalAsterisk = styled.span`
    font-size: ${tokens.typography.fontSize['sm-10px']};
    color: ${tokens.colors.brand.red[500]};
    font-weight: ${tokens.typography.fontWeights.bold};
`;

// Mobile-only module summary components (from sidebar)
export const ModuleSummaryContainer = styled.div`
    display: none;
    @media (max-width: 1024px) {
        display: block;
        padding: 0;
        border-top: none;
    }
`;

export const ModuleSummaryHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const ModuleSummaryTopRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: ${tokens.typography.fontSize['md-12px']};
    width: 100%;
`;

export const ModuleSummaryTitleGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ModuleSummaryTitle = styled.div`
    font-weight: ${tokens.typography.fontWeights.semibold};
    color: ${tokens.colors.text.primary};
    font-size: ${tokens.typography.fontSize['md-12px']};
`;

export const ModuleSummaryMeta = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: ${tokens.typography.fontSize['sm-10px']};
    color: ${tokens.colors.text.secondary};
`;

export const ModuleSummaryAmount = styled.div`
    font-size: ${tokens.typography.fontSize['md-12px']};
    font-weight: ${tokens.typography.fontWeights.bold};
    color: ${tokens.colors.text.primary};
`;

export const ModuleItemsWrapper = styled.div`
    max-height: 300px;
    height: auto;
    width: 100%;
    overflow-y: auto;

    scrollbar-width: thin;
    scrollbar-color: var(--scrollbar-thumb-color, var(--scrollColor)) transparent;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: var(--scrollbar-thumb-color, var(--scrollColor));
        border-radius: 999px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }
`;

export const ModuleItemsContainer = styled.div`
    padding: 8px 0 12px 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-height: 0;
    box-sizing: border-box;
`;

export const ModuleItemRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: ${tokens.typography.fontSize['md-12px']};
    gap: 12px;
`;

export const ModuleItemName = styled.div`
    color: ${tokens.colors.text.primary};
`;

export const ModuleItemPrice = styled.div`
    font-size: ${tokens.typography.fontSize['md-12px']};
    font-weight: ${tokens.typography.fontWeights.bold};
    color: ${(props) => (props.$isCredit ? tokens.colors.states.success.default : tokens.colors.text.primary)};
    white-space: nowrap;
`;

export const SummarySection = styled.div`
    display: flex;
    flex-direction: column;
    padding: 4px 0;
    gap: 12px;
`;

export const MobileSummaryFooter = styled.div`
    display: none;
    @media (max-width: 1024px) {
        display: block;
        padding: 12px;
        border-top: 1px solid ${tokens.colors.surfaces["border-divider"]};
    }
`;
